// Internal list of HTML entities for escaping.
export default {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#x27;',
  '`': '&#x60;'
};



//////////////////
// WEBPACK FOOTER
// /home/ensapb/site/web/app/themes/ensapb/node_modules/underscore/modules/_escapeMap.js
// module id = 78
// module chunks = 0